import { fmtScore, scoreTone, toneClass } from '../lib/format';
import { cx } from './ui';

export default function ScoreBadge({ score, label, size = 'md' }: { score: number | null | undefined; label?: string; size?: 'sm' | 'md' | 'lg' }) {
  const tone = scoreTone(score);
  const s = { sm: 'text-sm', md: 'text-lg', lg: 'text-3xl' }[size];
  return (
    <div className="flex flex-col items-center leading-tight">
      <span className={cx('hud font-semibold', s, toneClass[tone])}>{fmtScore(score)}</span>
      {label && <span className="text-[10px] uppercase tracking-wide text-dim">{label}</span>}
    </div>
  );
}
